export enum PatternType {
    AboutUs = 0,
    PrivacyPolicy = 1,
    TermsAndConditions = 2,
}